class GalleryTopButtons extends HTMLElement {
  constructor () {
    super()

    const epigraphAR = document.querySelector('epigraph-ar')
    const btn360View = this.querySelector('.js-360-view')
    epigraphAR?.addEventListener('epigraph-valid-product', () => {
      btn360View.style.display = 'flex'
    })
  }
}

customElements.define('gallery-top-buttons', GalleryTopButtons)
